import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../api";
import { AxiosError } from "axios";
import { AttendanceLocalGuiche } from "../../../../@types/attendance-local-guiche";

export function useAttendanceLocalGuicheDelete(id: AttendanceLocalGuiche['id']) {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation({
        mutationKey: ["attendance-local", "guiche", "delete", id],
        mutationFn: async () => {
            const response = await apisiseci.delete<{ detail: string }>(
                `/cms/guiche_unidade/${id}/`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: async () => {
            toast.success("Guichê excluído com sucesso!");

            await queryClient.invalidateQueries({
                queryKey: ['attendance-local', 'guiche', 'list'],
            });
        },
        onError: (error: AxiosError<{ detail: string }>) => {
            toast.error(
                error?.response?.data.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });

    return mutation;
}
